const state = {
	currentTab: 'home',
	currentStep: 'one',
	isIgnoreStepOne: false,
	isEditStepOne: false
}
const mutations = {
	setStateTab(state, data) {
		state.currentTab = data
	},
	setStateStep(state, data) {
		state.currentStep = data
	},
	switchStepOneStatus(state, data) {
		state.isIgnoreStepOne = data
	},
	setEditStepOneStatus(state, data) {
		state.isEditStepOne = data
	}
}

export default {
	state,
	mutations
}
